import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Banner, BannerFullModel } from '../models/banner.model';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private bannerSubject: BehaviorSubject<BannerFullModel> = new BehaviorSubject<BannerFullModel>({ show: false });
  private incomingSubject = new BehaviorSubject<Banner | null>(null);

  /** Banner pushed over the websocket, including one that arrived before the dashboard was opened. */
  readonly incoming$ = this.incomingSubject.asObservable();

  get banner(): BehaviorSubject<BannerFullModel> {
    return this.bannerSubject;
  }

  public isVisible(): boolean {
    return !!this.bannerSubject.value?.show;
  }

  public publishIncoming(banner: Banner): void {
    this.incomingSubject.next(banner);
  }

  public showBanner(config: BannerFullModel): void {
    this.bannerSubject.next({
      ...config,
      show: true,
    });
  }

  public hideBanner(): void {
    this.incomingSubject.next(null);
    this.bannerSubject.next({
      show: false });
  }
}
